import { Component, Input } from '@angular/core';
import { QuotationCoverage } from '../../model/offer';
import { map } from 'rxjs';
import { ProcessType } from '../../services/process.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import * as fromProcess from '../../store/process/process.reducer';
import { QbeIcons } from 'qbe-components';
import { TrackingService } from '../../tracking/tracking.service';

@Component({
  selector: 'app-offer-table',
  templateUrl: './offer-table.component.html',
  styleUrls: ['./offer-table.component.scss'],
})
export class OfferTableComponent {
  @Input() coverages!: QuotationCoverage[];

  processKind$ = this.store.select(fromProcess.selectProcessKind);
  isResignation$ = this.processKind$.pipe(map((processKind) => processKind === ProcessType.RESIGNATION));

  protected readonly qbeIcons = QbeIcons;

  constructor(private store: Store<AppState>, private trackingService: TrackingService) {}

  trackingOpen(name: string) {
    this.trackingService.more(name);
  }
}
